module.exports = __webpack_public_path__ + "img/logo2.9e79e5ab.png";